import { useQuery } from 'react-query';
import { useEnrichmentApi } from '@/v2/entities/enrichment/Enrichment.api';

export function useGetEnrichments() {
  const enrichmentApi = useEnrichmentApi();

  return useQuery({
    queryKey: ['enrichments'],
    queryFn: async () => {
      return await enrichmentApi.getAll();
    },
  });
}
